import { theme } from '@kinetik/ui-kit';

import { SERVICE_AREA_TYPE } from '@/features/provider-profile/constants';

export const SERVICE_AREA_TYPE_TAG_PALETTE = Object.freeze({
  [SERVICE_AREA_TYPE.TERRITORY]: {
    background: theme.kinetik.color.accent.gold.soft,
    border: theme.kinetik.color.accent.gold.base,
    text: theme.kinetik.color.accent.gold.heavy,
  },
  [SERVICE_AREA_TYPE.REGION]: {
    background: theme.kinetik.color.accent.aqua.soft,
    border: theme.kinetik.color.accent.aqua.base,
    text: theme.kinetik.color.accent.aqua.heavy,
  },
  [SERVICE_AREA_TYPE.SUB_REGION]: {
    background: theme.kinetik.color.status.info.soft,
    border: theme.kinetik.color.status.info.base,
    text: theme.kinetik.color.status.info.heavy,
  },
  [SERVICE_AREA_TYPE.FACILITY]: {
    background: theme.kinetik.color.accent.violet.soft,
    border: theme.kinetik.color.accent.violet.base,
    text: theme.kinetik.color.accent.violet.heavy,
  },
});
